import { useState } from 'react';
import FullscreenOverlay from '../../../../ui/FullscreenOverlay';
import { SpokeFooterCTAs } from '../../SpokeFooterCTAs';
import { ListingHeaderActions } from '../../ListingHeaderActions';
import { HaloSpokeHeader } from '../../HaloSpokeHeader';
import { NeighborhoodSpokeContent } from './NeighborhoodSpokeContent';
import { footerButtonGroup, headerRight, spokeContainer } from './neighborhoodSpoke.styles';
import { NeighborhoodProvider, useNeighborhoodContextSafe } from '../context';

/**
 * NeighborhoodSpoke - FullscreenOverlay wrapper for mobile.
 *
 * Composes NeighborhoodSpokeContent with FullscreenOverlay Header/Body/Footer.
 * On desktop, NeighborhoodSpokeContent is rendered inside DetailPanel instead.
 *
 * Self-provides NeighborhoodProvider when rendered outside of one (e.g., when
 * triggered from ListingSummaryModule). Safe to nest because the provider uses
 * a singleton state manager.
 */
export const NeighborhoodSpoke = () => {
  const existingContext = useNeighborhoodContextSafe();
  const [isCommuteInputFocused, setIsCommuteInputFocused] = useState(false);

  const content = (
    <div className={spokeContainer} data-testid="neighborhood-spoke" role="dialog" aria-label="Neighborhood details">
      <HaloSpokeHeader
        title="Neighborhood"
        actions={
          <div className={headerRight}>
            <ListingHeaderActions />
          </div>
        }
      />

      <FullscreenOverlay.Body padding="edge-to-edge">
        <NeighborhoodSpokeContent onCommuteInputFocusChange={setIsCommuteInputFocused} />
      </FullscreenOverlay.Body>

      {!isCommuteInputFocused && (
        <FullscreenOverlay.Footer>
          <div className={footerButtonGroup} data-testid="neighborhood-spoke-footer">
            <SpokeFooterCTAs />
          </div>
        </FullscreenOverlay.Footer>
      )}
    </div>
  );

  if (existingContext) {
    return content;
  }

  return <NeighborhoodProvider>{content}</NeighborhoodProvider>;
};
